export var Entity;
(function (Entity) {
    Entity["INBOX"] = "INBOX";
    Entity["FORMS"] = "FORMS";
    Entity["SUBMISSIONS"] = "SUBMISSIONS";
})(Entity || (Entity = {}));
